export default __webpack_public_path__ + "static/gs-R-code-4c2dfd73631a3d2d35a23acb597ffa26.png";